import Slideshow, {SlideshowChangeEvent} from '~/app/elements/Slideshow';

/**
 * Класс обратного направления перелистывания.
 */
const CLASS_BACKWARDS = 'backwards';
/**
 * Скрипты слайдшоу завершили инициализацию.
 */
const CLASS_READY = 'ready';

/**
 * Фоновое слайдшоу на главной.
 */
function slideshow(): void
{
	const container = document.querySelector( '#home>div.slideshow' );
	
	if ( !container )
	{
		return;
	}
	
	const slidesList = container.querySelector( 'ul.slides' ) as HTMLElement;
	const controls = container.querySelector( 'div.controls' ) as HTMLElement;
	const btnPrev = controls.querySelector( 'button.prev' ) as HTMLElement;
	const btnNext = controls.querySelector( 'button.next' ) as HTMLElement;
	const currentSlide = controls.querySelector( 'span.counter>span.current' ) as HTMLElement;
	const slidesCount = controls.querySelector( 'span.counter>span.total' ) as HTMLElement;
	
	const slideshow = new Slideshow( slidesList );
	
	let changedByButton: boolean = false;
	
	slidesList.addEventListener(
		Slideshow.EVENT_CHANGE,
		( event: SlideshowChangeEvent ) =>
		{
			// При автоматическом листании направление всегда «вперёд».
			if ( !changedByButton )
			{
				slidesList.classList.remove( CLASS_BACKWARDS );
			}
			
			changedByButton = false;
			
			currentSlide.textContent = String( event.detail.currentSlide + 1 );
			slidesCount.textContent = String( event.detail.slidesCount );
		},
	);
	
	const toNext = (): void =>
	{
		changedByButton = true;
		slidesList.classList.remove( CLASS_BACKWARDS );
		slideshow.next();
	};
	
	const toPrev = (): void =>
	{
		changedByButton = true;
		slidesList.classList.add( CLASS_BACKWARDS );
		slideshow.prev();
	};
	
	btnPrev.addEventListener( 'click', toPrev );
	btnNext.addEventListener( 'click', toNext );
	
	slideshow.toSlide( 0 );
	slideshow.autoSlideshow( 7000 );
	
	container.classList.add( CLASS_READY );
}

/**
 * Module.
 */
export {
	slideshow as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Index/Header/slideshow.ts